export const defaultParams = { doInitialRequest: true }
